// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';
import { capitalize } from '@ember/string';
import { computed, get } from '@ember/object';
import { A } from '@ember/array';

const POSSIBLE_ENTRY_STATUSES = [
  { key: 'emailStatus', eventReportName: 'email_notification', title: 'Email' },
  { key: 'pushStatus', eventReportName: 'push_notification', title: 'Push' },
  { key: 'slackStatus', eventReportName: 'slack_notification', title: 'Slack DM' },
  { key: 'smsStatus', eventReportName: 'sms_notification', title: 'SMS' },
];

/**
 * @param {Model<Entry>}               entry
 * @param {Array}                     eventReports
 */
// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',

  notifications: computed(
    'eventReports.@each.status',
    'entry.{emailStatus,pushStatus,slackStatus,smsStatus}',
    function () {
      const eventReports = get(this, 'eventReports') || [];
      const eventReportNames = eventReports.mapBy('name');

      // filter out duplicate and ignored entry notification statuses, and normalize their format
      const statuses = POSSIBLE_ENTRY_STATUSES.reduce((validStatuses, possibleStatus) => {
        const noEventReport = !eventReportNames.includes(possibleStatus.eventReportName);
        const title = get(possibleStatus, 'title');
        const status = get(this, `entry.${possibleStatus.key}`);
        const shouldBeShown = !(status === 'not_sent' || status === 'disabled');
        if (noEventReport && status && shouldBeShown) {
          validStatuses.push({
            title,
            statusMessage: capitalize(status),
            done: status === 'sent' || status === 'delivered',
            queued: status === 'queued',
            inProgress: status === 'sending',
            failed: status === 'failed' || status === 'undelivered',
            expired: false,
            ignored: false,
          });
        }
        return validStatuses;
      }, []);

      // merge entry statuses with event reports
      return A([...statuses, ...eventReports]).sortBy('title');
    }
  ),
});
